import { createTheme, alpha } from '@mui/material/styles'
import { checkboxClasses } from '@mui/material/Checkbox'

const theme = createTheme({
    logo: 'gpsiLogo.svg',
    devexpress: 'material.base',
    scheme: 'Fleetconnect',
    mapStyle: 'mapstyle.json',
    palette: {
        mode: 'dark',
        primary: {
            main: '#4b4b4b',
            contrastText: '#979898',
            dark: '#2b2b2b',
            light: '#4b4b4b',
            trans: '#ffffff00',
        },
        secondary: {
            main: '#f78f1e',
            trans: '#f78f1e99',
            dark: '#bb701f',
            contrastText: '#ffffff',
            level1: '#352a21',
            level2: '#553b20',
            level3: '#754c20',
            level4: '#965c1f',
            level5: '#b76e1f',
            level6: '#d77e1e',
            level7: '#f78f1e',
        },
        text: {
            primary: '#979898',
            secondary: '#ffffff',
        },
        background: {
            default: '#2b2b2b',
            paper: '#323232',
        },
        border: {
            default: '#4b4b4b',
            secondary: '#ffffff',
        },
        error: {
            main: '#9e2121',
        },
        warning: {
            main: '#bb701f',
        },
        success: {
            main: '#32cd32',
        },
        info: {
            main: '#6d7579',
        },
        tripType: {
            unassigned: '#9e2121',
            assigned: '#f78f1e',
        },
        spcBooking: {
            main: '#f78f1e',
            inprog: '#456724',
            comp: '#965c1f',
            inv: '#9e2121',
        },
        spcBookingNotOwned: {
            main: '#bb701f',
            inprog: '#456724',
            comp: '#965c1f',
            inv: '#9e2121',
        },
        pieChart: ['#f78f1e','#d77e1e','#b76e1f','#965c1f','#754c20','#553b20','#352a21'],
    },
    header: {
        background: "#2B2B2B",
        selector: {
            cursor: 'pointer',
            color: "#f78f1e",
            fontSize: "14px",
            textAlign: "end",
            width: 'max-content !important',
            '&:hover': {
                backgroundColor: "#242424",
                borderRadius: '4px',
                paddingTop: '2px',
                paddingBottom: '2px',
                paddingLeft: '8px',
                paddingRight: '8px',
            }
        },
        search: {
            color: "#F3F3F9",
            fill: "#979898",
            fontSize: "14px",
            width: "15%",
            backgroundColor: "#242424",
            borderRadius: '4px',
            paddingTop: '2px',
            paddingBottom: '2px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    sidebar: {
        background: "#000000",
        header: {
            color: '#515151',
            brand: {
                color: "#2b2b2b",
            },
        },
    },
    spacing: 4,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1440,
        },
    },
    typography: {
        fontFamily: "'Open Sans', Roboto, 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', 'Lucida Grande', sans-serif",
        //fontFamily: [
        //    "Inter",
        //    "-apple-system",
        //    "BlinkMacSystemFont",
        //    '"Segoe UI"',
        //    "Roboto",
        //    '"Helvetica Neue"',
        //    "Arial",
        //    "sans-serif",
        //    '"Apple Color Emoji"',
        //    '"Segoe UI Emoji"',
        //    '"Segoe UI Symbol"',
        //].join(","),
        fontSize: 13,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
        h1: {
            fontSize: "2rem",
            fontWeight: 600,
            lineHeight: 1.25,
        },
        h2: {
            fontSize: "1.75rem",
            fontWeight: 600,
            lineHeight: 1.25,
        },
        h3: {
            fontSize: "1.5rem",
            fontWeight: 600,
            lineHeight: 1.25,
        },
        h4: {
            fontSize: "1.125rem",
            fontWeight: 500,
            lineHeight: 1.25,
        },
        h5: {
            fontSize: "1.0625rem",
            fontWeight: 500,
            lineHeight: 1.25,
        },
        h6: {
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.25,
        },
        menuSubTitle: {
            fontSize: 12,
            fontWeight: 600,
        },
        menuItemTitle: {
            fontSize: 16,
            fontWeight: 400,
        },
        formLabel: {
            fontSize: 14,
            fontWeight: 200,
            lineHeight: 1.2857,
            color: '#ffffff99',
        },
        body1: {
            fontSize: 12,
        },
        body2: {
            fontSize: 9,
            fontWeight: 600,
        },
        button: {
            textTransform: "none",
        },
    },
    zIndex: {
        content: 900,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundImage: "url(img/fc_bodybg.jpg)",
                },
                '&.form-buttons': {
                    alignSelf: 'flex-end',
                },
                '&.dx-datagrid-header-panel': {
                    padding: '0 8px',
                },
                '&.toolbar-separator': {
                    height: '36px',
                    margin: '0px 8px 0 8px',
                    borderLeft: '1px solid #4b4b4b',
                },
                '&.toolbar-menu-separator': {
                    height: '1px',
                    borderBottom: '1px solid #4b4b4b',
                },
                '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                    backgroundColor: 'transparent',
                    width: 5
                },
                '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                    borderRadius: 2,
                    //backgroundColor: alpha('#fff', 0.10),
                    minHeight: 10,
                    maxHeight: 50,
                    border: 0
                },
                '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
                    backgroundColor: '#515151'
                },
                '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
                    backgroundColor: '#515151'
                },
                '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#515151'
                },
                '&.button': {
                    minWidth: '100px',
                },
                '&.dx-button.dx-button-success': {
                    backgroundColor: '#19711b',
                },
                '&.dx-button.dx-button-success.dx-state-focused': {
                    backgroundColor: '#176519',
                },
                '&.dx-button.dx-button-success.dx-state-hover': {
                    backgroundColor: '#176519',
                },
                // ***** Devexpress theme global overrides *****
                // *** remove *** all references to .dx-theme-material-typography
                '&.dx-accordion-item-body': {
                    padding: '10px 16px',
                },
                '&.dx-scheduler-timeline .dx-scheduler-group-flex-container .dx-scheduler-group-header': {
                    width: 'auto', 
                },
                '&.dx-scheduler-header': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-scheduler-header-panel-container': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-scheduler-header-panel-empty-cell': {
                    width: '311px !important',
                },
                '&.dx-scheduler-group-column-count-one .dx-scheduler-header-panel-empty-cell': {
                    width: '311px',
                },
                '&.dx-form-group-with-caption': {
                    backgroundColor: '#323232',
                    padding: '12px',
                    borderRadius: '4px',
                },
                '&.dx-form-group-caption': {
                    fontSize: '16px',
                    color: '#f78f1e',
                },
                '&.dx-designer .dx-designer-viewport .dxrd-designer-wrapper.dxrd-designer-wrapper .dxrd-right-panel .dxrd-right-panel-header': {
                    color: '#f78f1e',
                },
                '&.dx-designer-viewport .dx-editors .dx-fieldset .dx-field .dx-field-value, .dx-designer-viewport .dx-editors .dx-editors .dx-fieldset .dx-field .dx-field-value': {
                    width: '100%',
                },
                '&.dxrd-preview.dxrd-designer-wrapper .dx-texteditor.dx-editor-filled': {
                    backgroundColor: '#2e2e2e',
                },
                '&.dxrd-preview.dxrd-designer-wrapper .dx-texteditor.dx-editor-filled.dx-state-hover': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dxrd-preview.dxrd-designer-wrapper .dxrd-preview-parameters-wrapper .dxrd-right-panel-content .dx-field-label.dx-accordion-header.dx-accordion-empty': {
                    paddingBottom: '8px',
                    paddingTop: '8px',
                    borderRadius: '4px',
                },
                '&.dxrd-right-panel-content .dx-switch .dx-switch-wrapper': {
                    height: 'unset',
                    width: 'unset',
                },
                '&.dxrd-right-panel-content .dx-field': {
                    flexDirection: 'column',
                },
                '&.dxrd-right-panel-content .dx-field-value.dx-switch, .dx-field-value:not(.dx-widget) > .dx-switch': {
                    float: 'unset',
                },
                '&.dxrd-right-panel-content .dx-treeview-item.dx-state-hover': {
                    backgroundColor: '#1a1a1a29',
                },
                '&.dx-button-mode-contained': {
                    backgroundColor: '#464646',
                },
                '&.dx-progressbar-status': {
                    color: '#f78f1e',
                },
                '&.dx-button-has-text': {
                    backgroundColor: '#3e3e3e',
                },
                '&.dx-designer .dx-button-content': {
                    padding: '8px'
                },
                '&.dx-button-has-text .dx-button-content': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
                '&.dx-button.dx-state-focused, .dx-button.dx-state-hover': {
                    backgroundColor: '#4c4c4c',
                },
                '&.dx-scheduler-header .dx-toolbar .dx-button, .dx-scheduler-header .dx-toolbar .dx-button .dx-icon': {
                    backgroundColor: '#f78f1e14',
                },
                '&.dxrdp-parameters-submit.dx-state-hover': {
                    backgroundColor: '#bb701f',
                },
                '&.dxrdp-parameters-reset.dx-state-hover': {
                    backgroundColor: '#4c4c4c',
                },
                '&.dx-button-text': {
                    textTransform: 'none',
                    fontWeight: '400',
                },
                '&.tbarbutton.dx-button.dx-button-default': {
                    color: '#f78f1e',
                    backgroundColor: '#f78f1e14',
                    fontSize: '13px',
                },
                '&.tbarbutton.dx-button.dx-button-default.dx-state-hover': {
                    backgroundColor: '#39322aa1',
                },
                '&.tbarbutton.dx-button.dx-button-default.dx-state-focused': {
                    backgroundColor: '#39322aa1',
                },
                //'&.dx-button.dx-button-default': {
                //    color: '#2b2b2b',
                //},
                '&.dx-button-mode-contained.dx-button-default': {
                    color: '#2b2b2b',
                },
                '&.dx-button.dx-button-default.dx-state-disabled': {
                    backgroundColor: 'rgba(151,152,152,.12)',
                },
                //'&.dx-button .dx-button-content': {
                //    padding: '8px',
                //},
                '&.smallicon': {
                    width: 'unset !important',
                    height: 'unset !important',
                    fontSize: '12px !important',
                },
                '&.dx-button .dx-icon': {
                    width: '24px',
                    height: '24px',
                    fontSize: '24px',
                },
                '&.dx-button-has-text .dx-icon': {
                    marginRight: '12px',
                },
                '&.dx-button-has-text .dx-icon.dx-icon-right, .dx-rtl .dx-button-has-text .dx-icon, .dx-rtl.dx-button-has-text .dx-icon': {
                    marginLeft: '12px',
                },
                '&.dx-rtl .dx-button-has-text .dx-icon.dx-icon-right, .dx-rtl.dx-button-has-text .dx-icon.dx-icon-right': {
                    marginRight: '12px',
                },
                '&.dx-button-has-icon .dx-button-content': {
                    padding: '6px',
                },
                '&.dx-button-has-icon .dx-icon': {
                    width: '24px',
                    height: '24px',
                    fontSize: '24px',
                },
                '&.mapDrwBtn.dx-button-has-icon .dx-icon': {
                    width: '16px',
                    height: '16px',
                    fontSize: '16px',
                },
                '&.mapBtn.dx-button-has-icon .dx-icon': {
                    width: '20px',
                    height: '20px',
                    fontSize: '20px',
                },
                '&.dx-button.dx-button-has-icon.dx-state-hover': {
                    backgroundColor: '#323232',
                    color: '#f78f1e',
                },
                '&.dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard)': {
                    borderRadius: '4px',//'inherit',
                },
                '&.dx-button.dx-button-back .dx-button-content': {
                    padding: '6px',
                },
                '&.dx-button.dx-button-back .dx-icon': {
                    width: '24px',
                    height: '24px',
                    fontSize: '24px',
                },
                '&.dx-button-has-icon.dx-button-has-text .dx-button-content': {
                    padding: '6px 16px',
                },
                //'&.dx-tooltip-wrapper': {
                //    backgroundColor: '#2b2b2b',
                //},
                '&.dx-accordion-item-title': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-accordion-item-title-caption': {
                    fontSize: '16px',
                    color: '#f78f1e',
                },
                '&.dx-accordion-item': {
                    backgroundColor: '#2b2b2b',
                    marginTop: '8px',
                    borderRadius: '4px',
                },
                //'&.dx-accordion-item.dx-state-hover > .dx-accordion-item-title': {
                //    backgroundColor: 'rgba(255,255,255,.02)',
                //},
                '&.dx-show-clear-button .dx-icon-clear': {
                    color: '#878787',
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-field-item-label-text': {
                    fontWeight: 200,
                },
                '&.dx-toast-info .dx-toast-icon': {
                    backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAABoklEQVRIx63WPUvDQBjA8QMFsZNLlgpxtINjBsFVqINghm4dRAe/Rpdm6UcQHERwUYdAJ8HvkKHEQdrPEBQUrf7PoabtveSSSrit3PPjeve8RCCsyyMkIiYlAzJSYiJCPPt+248BfRKkdSX0CcoZnx7jAiJfY3r4LqbNsITI15B2EdNlVBGRSEZ0bUyXyQqIRDJZQIu/M1oRmZ2ovcz4zjt558NxR/6C6Vk2fHLPOXtsIhA0aHHGA1/Gvl7OBMYT/3BF05poTS5Be/5gxvQ15JWjgtyerWPelP19hMDTMvabQyciEJwoJ0rwBKF2lutSRCC4UWJCQaQx+5WYAyUmEsQas1WJ2VJiYkGqMTuVmG0lJhVkGnNaiblQYjKhZYHkmY1SpMGLEoN5Gskt605kjTstIjPvRiJ50tuSksePxv7UfKm8HAe0DGKXgZbB85eKHLWdKkjHUpjzvAmdHaUKIgnNmrIzLiTBs1W4ybiQvwq39RuV6TB1jpvA1f1yxo0sdT9XLy5DlF5cPBmmq0yG2uZUbVOzthle2xdFbd83//za+gXw/JH9LjmoAgAAAABJRU5ErkJggg==)',
                },
                '&.dx-toast-warning .dx-toast-icon': {
                    backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAABJklEQVRIx62WvW2EQBBGpwlSArdgSrBESuKIQhySLJJbcAuXrXTZteCAAG3GlWBRwVsHB+Ykw8zeafVlaPSY/1lBdlXQ0OMJzMBMwNPTUOzb732scAzEXQ04KhtT0jEdIFZNdJQapuZsIFadqY8wLWMiJBIZafcwLdcHIJHIdQNt4YwPQm4e1feYMjkn/3NUbpjuSUgk0q2YSinx5xL0SSl/dcM45V8r5qLYOEQoDjs2FTNQCI0a+deC+VatGqFPwugD0gs+A8YLQTW4LJgf1SoIcxJG751ZIAMGy5sp1ZuQgHkxMMGqVJq81Tdp6q0unnhFeDMK3lgz9b6k+MOaKX3CUzDO3jd2UH/7JtP2y7aLM12GbHcq29XMdsOzvSiyvW+efG39AmPXSbHWZjgLAAAAAElFTkSuQmCC)',
                },
                '&.dx-toast-error .dx-toast-icon': {
                    backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAABeklEQVRIx62WMWrDQBBFx01I5zQinQ5hdINA3Kp3mUNEnSBIdwgEcgeBC18gVRojjDr7BklUxAE3b1NYihVrdmWbZbpl9FjN/zOzgqgREJNTUFEDNRUFOTGBnq8dRmQsMWosyYiGMSEpawuijTUpoQszZT6AaGPO1IaZsToRYjCsmGmYGZszIAbD5gA6/M7qTMj+RtMuJjy5Jv0ahQdMeiHEYEhbTKRK/KN+9K3IH+0xmZK+4Jb33mnChM/eaYYIgeLYBdcI4yNQgiBM+Oo5OxBi5S5l0ztdUNJoGrPr5cdCrtbgGOSCGHKhsCjQBbkhhkKorFK2oKsBiKESaocnys58sUMMtYDTXA8NZMSbIwv3bZJO/48VH3VuY6/NYwO4V+Tv1aYYgMTsVB8dKZUPQmyG/OcbzcUvijot6IYPzcVaT225UyQuCRjxrGyLwNbhW54Un5S8KrmZa96cGn/zxtP08zaLPW0Gb3vK29b0tsO9vSi8vW8ufG39AnvvGenmMu5AAAAAAElFTkSuQmCC)',
                },
                '&.dx-toast-success .dx-toast-icon': {
                    backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAABlklEQVRIx62Wv0rDUBSHTxE6uHTKGhDEzS2jg4vUMeBmX8BR8AFiJQEfwck3cAh2cxBcXEup3VoHF3UxS1FBvuvQhPy5N0lTwplyknz33HN+95wriNEsXAJCZkRAxIyQABfL/L3J6eAzRhltjI9Tj7HxmJcgEpvjYVdh+oxqEImN6JdhBkzXhCgUUwYmzIBFA4hCsUhB6XamDSGriPpZjL12TvQc2SnG2xCiUHgJxqktcdbe+SmU31lh/AaQJQ4HfOR8PiJYpYrVDU4RhD1+c8q2BLdBLNdxXW8KflcI1obcs4UgnGlvAiE0/DDhW/O90EMQDnMbWlkozDTnMz2OC6AvdhGEHT4Ny86EqOB6i1fNgv44QhC2mRi3Gwlozqs4kSnoHEHocFdWQT0ahWKYA93GT5elyY9MucmDHukiCCeGuDO5CUteJaAOgrDPskIKYZVuhpkG/1qpqKBaxRcIQpeHGmG6dWfKM0hfnxZW/Ql/qj0k/ib9Rh83Tqvdr7Ve3NJkaG1OtTY1W5vhrd0oWrvfbHjb+gdn1DPEHv9HmQAAAABJRU5ErkJggg==)',
                },
                '&.dx-toolbar .dx-button .dx-icon:hover': {
                    color: '#f78f1e',
                },
                '&.dx-designer-viewport .dxd-icon-highlighted:hover .dxd-icon-fill': {
                    fill: '#f78f1e',
                    opacity: 1,
                },
                '&.dx-list-item.dx-state-active, .dx-list-item.dx-state-hover': {
                    color: '#f78f1e',
                },
                '&.dx-device-mobile .dx-list-item.dx-state-active, .dx-device-mobile .dx-list-item.dx-state-hover': {
                    color: '#f78f1e',
                },
                '&.dx-device-mobile .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused': {
                    color: '#f78f1e',
                },
                '&.dx-device-mobile .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused.dx-list-item-selected': {
                    backgroundColor: '#2b2b2b',
                    color: '#f78f1e',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected.dx-state-hover:not(.dx-state-focused)': {
                    backgroundColor: '#2b2b2b',
                    color: '#f78f1e',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-active, .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-active .dx-list-slide-item-content': {
                    backgroundColor: 'transparent'
                },
                '&.dx-popover-arrow::after': {
                    background: '#323232',
                },
                '&.dx-treeview-node-loadindicator': {
                    right: '4px',
                },
                '&.dx-treeview-toggle-item-visibility.dx-state-disabled': {
                    visibility: 'hidden',
                },
                '&.dx-calendar-navigator': {
                    textAlign: 'center',
                },
                '&.dx-toolbar-menu-container': {
                    padding: '0 5px',
                },
                '&.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button .dx-button-text, .dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button .dx-button-text': {
                    fontSize: '16px',
                },
                '&.dx-popover-wrapper .dx-popup-title.dx-toolbar': {
                    paddingLeft: '15px',
                },
                '&.dx-popover-wrapper .dx-rtl.dx-popup-title.dx-toolbar': {
                    paddingRight: '15px',
                    paddingLeft: '0',
                },
                '&.dx-pager': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-datagrid-rowsview': {
                    backgroundColor: '#323232',
                },
                '&.dx-datagrid-rowsview .dx-row:hover': {
                    backgroundColor: '#333333',
                    cursor: 'pointer',
                },
                '&.dx-datagrid .dx-sort-up::before': {
                    color: '#565757',
                },
                '&.dx-datagrid .dx-sort-down::before': {
                    color: '#565757',
                },
                '&.dx-drawer-panel-content': {
                    backgroundColor: '#000',
                },
                '&.dx-button-mode-contained': {
                    transition: 'all 0.3s ease',
                },
                '&.dx-accessibility-toolbar-item': {
                    transition: 'all 0.3s ease',
                },
                '&.dx-button-mode-contained.dx-state-selected': {
                    backgroundColor: '#f78f1e',
                },
                '&.dx-button-mode-contained.dx-state-selected.dx-state-hover': {
                    backgroundColor: '#bb701f',
                },
                '&.dx-button-mode-contained.dx-state-selected, .dx-button-mode-contained.dx-state-selected .dx-icon': {
                    color: '#2b2b2b',
                },
                '&.dx-designer-viewport .dx-button': {
                    borderRadius: '4px',
                },
                '&.dx-designer-viewport .dxd-back-contrast .dxd-icon-fill': {
                    fill: '#979898',
                },
                '&.dx-designer-viewport .dxd-state-active .dxd-icon-fill, .dx-designer-viewport .dxd-back-contrast .dxd-back-highlighted:hover .dxd-icon-fill, .dx-designer-viewport .dx-menu-item .dx-state-focused.dxd-icon-fill': {
                    fill: '#f78f1e',
                },
                '&.dxrdp-parameters-submit': {
                    background: '#f78f1e',
                    color: '#2b2b2b',
                },
                '&.dx-layout-manager .dx-label-h-align.dx-flex-layout:not(.dx-field-item-label-align)': {
                    alignItems: 'center',
                },
                '&.dx-layout-manager .dx-label-h-align.dx-flex-layout .dx-field-item-content, .dx-layout-manager .dx-label-h-align.dx-flex-layout .dx-field-item-content-wrapper': {
                    display: 'flex',
                },
                '&.dx-field-item-label-location-top': {
                    padding: '0 0 3px',
                    paddingInlineStart: '0',
                    paddingInlineEnd: '0',
                },
                '&.dx-layout-manager .dx-field-item': {
                    paddingBottom: '0',
                    fontSize: '14px',
                },
                '&.dx-invalid-message-bottom .dx-invalid-message > .dx-overlay-content': {
                    padding: '0',
                },
                '&.dx-invalid-message > .dx-overlay-content': {
                    padding: '0',
                },
                '&.dx-treeview-item-with-checkbox .dx-checkbox': {
                    top: '10px',
                    left: '25px',
                },
                '&.dx-checkbox.dx-checkbox-checked.dx-state-disabled .dx-checkbox-icon, .dx-checkbox.dx-checkbox-checked.dx-state-readonly .dx-checkbox-icon, .dx-checkbox.dx-checkbox-indeterminate.dx-state-disabled .dx-checkbox-icon, .dx-checkbox.dx-checkbox-indeterminate.dx-state-readonly .dx-checkbox-icon': {
                    backgroundColor: '#979898',
                },
                '&.dx-tabs': {
                    backgroundColor: 'transparent',
                    width: 'inherit',
                    textAlign: 'left',
                },
                '&.dx-tab': {
                    backgroundColor: 'transparent',
                },
                '&.dx-tab.dx-state-hover': {
                    color: '#fff',
                },
                '&.dx-tab.dx-tab-selected, .dx-tab.dx-tab-selected .dx-icon': {
                    color: '#fff',
                },
                '&.dx-tab.dx-tab-selected::before': {
                    height: '1px',
                },
                '&.dx-tab-content, .dx-tab-text': {
                    fontWeight: 400,
                },
                '&.dx-texteditor-label': {
                    color: '#4b4b4b',
                },
                '&.dx-texteditor-input': {
                    color: '#ffffff',
                    fontSize: '14px',
                },
                '&.dx-texteditor.dx-editor-filled .dx-lookup-field,.dx-texteditor.dx-editor-filled .dx-placeholder::before, .dx-texteditor.dx-editor-filled .dx-texteditor-input, .dx-texteditor.dx-editor-outlined .dx-lookup-field, .dx-texteditor.dx-editor-outlined .dx-placeholder::before, .dx-texteditor.dx-editor-outlined .dx-texteditor-input': {
                    padding: '8px',
                },
                '&.dx-searchbox.dx-editor-filled .dx-placeholder::before, .dx-searchbox.dx-editor-filled .dx-texteditor-input, .dx-searchbox.dx-editor-outlined .dx-placeholder::before, .dx-searchbox.dx-editor-outlined .dx-texteditor-input': {
                    paddingLeft: '46px',
                },
                '&.dx-texteditor.dx-editor-filled': {
                    backgroundColor: '#323232',
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px',
                    flexGrow: 1,
                },
                '&.dx-texteditor.dx-editor-filled.dx-state-hover': {
                    backgroundColor: '#242424',
                },
                '&.dx-texteditor.dx-editor-filled.dx-state-hover::after': {
                    borderBottomColor: '#979898',
                },
                //.dx-texteditor.dx-editor-filled::after *** remove***
                '&.dx-searchbox .dx-icon-search': {
                    color: '#4b4b4b',
                },
                '&.dx-treeview-item.dx-state-disabled': {
                    padding: '10px 10px 2px 10px',
                },
                // .dx-treeview-node *** remove***
                '&.dx-treeview-item-with-checkbox .dx-treeview-item': {
                    paddingLeft: '25px',
                    margin: '4px 0',
                },
                '&.dx-treeview-select-all-item': {
                    padding: '6px',
                },
                '&.dx-treeview-item': {
                    padding: '6px 0 6px 10px',
                    borderRadius: '4px',
                    margin: '4px 10px',
                },
                '&.dx-treeview-toggle-item-visibility': {
                    font: '18px/ 18px DXIcons',
                    height: '34px',
                },
                '&.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened': {
                    font: '18px/ 18px DXIcons',
                },
                '&.dxrd-right-panel-content .dx-treeview-search': {
                    backgroundColor: '#2b2b2b',
                },
                '&.dxrd-right-panel-content .dx-texteditor.dx-editor-filled': {
                    borderTopLeftRadius: '6px',
                    borderTopRightRadius: '6px',
                },
                '&.dx-toolbar': {
                    backgroundColor: '#2b2b2b',
                    padding: '0 12px 0 12px',
                },
                '&.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-button-content': {
                    padding: '6px',
                },
                '&.dx-toolbar-button.dx-toolbar-text-auto-hide .dx-button .dx-icon': {
                    width: '24px',
                    height: '24px',
                    fontSize: '24px',
                },
                '&.dx-list-group-header': {
                    padding: '2px 8px',
                },
                '&.dx-list-item-content': {
                    padding: '8px 24px',
                    margin: '4px 0 4px 0',
                },
                '&.dx-list-next-button .dx-button .dx-button-content': {
                    padding: '6px 16px',
                },
                '&.dx-list-next-button .dx-button .dx-icon': {
                    marginRight: '12px',
                },
                '&.dx-list-next-button .dx-button .dx-icon.dx-icon-right, .dx-rtl .dx-list-next-button .dx-button .dx-icon, .dx-rtl.dx-list-next-button .dx-button .dx-icon': {
                    marginLeft: '12px',
                },
                '&.dx-rtl .dx-list-next-button .dx-button .dx-icon.dx-icon-right, .dx-rtl.dx-list-next-button .dx-button .dx-icon.dx-icon-right': {
                    marginRight: '12px',
                },
                '&.dx-list-item-after-bag.dx-list-static-delete-button-container': {
                    width: '43px',
                },
                // .dx-list-group:not(.dx-list-group-collapsed):not(:last-child) *** remove***
                '&.dx-popup-title': {
                    padding: '0 8px 0 24px',
                    color: '#f78f1e',
                },
                '&.dx-popup-title.dx-toolbar': {
                    padding: '0 8px 0 24px',
                },
                '&.dx-popup-bottom.dx-toolbar': {
                    padding: '0 8px 0 24px',
                },
                '&.dx-popup-content': {
                    backgroundColor: '#2b2b2b',
                    padding: '18px 24px 24px',
                },
                '&.tripmap .dx-popup-content': {
                    padding: 'unset',
                },
                '&.dx-dropdownbutton-action.dx-button-has-icon:not(.dx-button-has-text) .dx-button-content': {
                    paddingInline: '8px',
                },
                '&.dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown, .dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-icon.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown, .dx-dropdownbutton.dx-dropdownbutton-has-arrow .dx-button-has-text.dx-buttongroup-last-item .dx-button-content .dx-icon-spindown': {
                    height: '24px',
                    backgroundSize: '24px 24px',
                    fontSize: '24px',
                    lineHeight: '24px',
                },
                '&.dx-tile': {
                    backgroundColor: '#000000',
                    borderRadius : '6px',
                },
                // .dx-toast-icon *** modify *** display: none;
                // *** add toast icons ***
                // .dx-popover-wrapper .dx-popover-arrow *** remove ***
                '&.dx-lookup-empty .dx-lookup-field': {
                    color: '#4b4b4b',
                },
                '&.dx-tag-content': {
                    padding: '4px 32px 3px 12px',
                    color: '#2b2b2b',
                },
                '&.dx-tagbox.dx-editor-filled .dx-texteditor-input, .dx-tagbox.dx-editor-outlined .dx-texteditor-input': {
                    marginTop: '4px',
                },
                '&.dx-tagbox.dx-editor-filled .dx-tag-container, .dx-tagbox.dx-editor-outlined .dx-tag-container': {
                    padding: '4px 12px 4px 1px',
                },
                '&.dx-tag': {
                    margin: '4px',
                },
                '&.dx-datagrid-borders > .dx-datagrid-headers, .dx-datagrid-borders > .dx-datagrid-rowsview, .dx-datagrid-borders > .dx-datagrid-total-footer': {
                    borderLeft: '1px solid #3f3f3f',
                    borderRight: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-borders > .dx-datagrid-rowsview, .dx-datagrid-borders > .dx-datagrid-total-footer': {
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-borders > .dx-datagrid-filter-panel, .dx-datagrid-borders > .dx-datagrid-headers': {
                    borderTop: '1px solid #3f3f3f',
                },
                // .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td .dx-header-filter:focus, .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus
                // *** remove *** outline: #d07c22 solid 2px;
                '&.dx-datagrid .dx-header-filter': {
                    font: 'var(--fa-font-solid)',
                //    font: "14px/ 1 'Font Awesome 7 Pro'",
                },
                '&.dx-datagrid .dx-header-filter-empty': {
                    color: '#4c4c4c',
                },
                '&.dx-datagrid .dx-header-filter::before': {
                    content: '"\\e17c"',
                //    color: '#3c3d3d',
                },
                '&.dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none, .dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none, .dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none, .dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none, .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none': {
                    borderLeft: '2px solid #3f3f3f',
                    borderRight: '2px solid #3f3f3f',
                },
                '&.dx-rtl .dx-datagrid .dx-datagrid-headers .dx-row td.dx-pointer-events-none, .dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-data-row td.dx-pointer-events-none, .dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-freespace-row td.dx-pointer-events-none, .dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-header-row td.dx-pointer-events-none, .dx-rtl .dx-datagrid .dx-datagrid-rowsview .dx-virtual-row td.dx-pointer-events-none': {
                    borderLeft: '2px solid #3f3f3f',
                    borderRight: '2px solid #3f3f3f',
                },
                '&.dx-datagrid .dx-header-filter, .dx-datagrid .dx-sort-down, .dx-datagrid .dx-sort-up, .dx-datagrid-container .dx-header-filter, .dx-datagrid-container .dx-sort-down, .dx-datagrid-container .dx-sort-up': {
                    fontSize: '14px',
                },
                '&.dx-datagrid': {
                    backgroundColor: 'transparent',
                },
                '&.darkgrid .dx-datagrid-rowsview .dx-row:hover': {
                    backgroundColor: '#101010',
                },
                '&.darkgrid .dx-progressbar-container': {
                    backgroundColor: 'unset',
                    height: '8px',
                },
                '&.darkgrid .dx-datagrid .dx-row-lines > td': {
                    borderBottom: 'unset',
                },
                '&.dx-datagrid .dx-row-lines > td': {
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-rowsview .dx-row.dx-group-row td': {
                    borderTopColor: '#3f3f3f',
                    borderBottomColor: '#3f3f3f',
                },
                '&.darkgrid .dx-datagrid .dx-row > td': {
                    padding: '4px',
                },
                '&.dx-datagrid .dx-row > td': {
                    padding: '14px 8px',
                    fontSize: '13px',
                },
                '&.dx-datagrid-headers': {
                    //borderBottom: '1px solid #3f3f3f',
                    backgroundColor: '#303030',
                },
                '&.darkgrid .dx-datagrid-headers': {
                    //borderBottom: '1px solid #3f3f3f',
                    backgroundColor: 'transparent',
                    marginBottom: '8px',
                },
                '&.darkgrid .dx-datagrid-headers .dx-datagrid-table .dx-row > td': {
                    //borderBottom: '1px solid #3f3f3f',
                    fontSize: '13px',
                },
                '&.dx-datagrid-headers .dx-datagrid-table .dx-row > td': {
                    borderBottom: '1px solid #3f3f3f',
                    fontSize: '13px',
                },
                // .dx-datagrid-headers .dx-datagrid-table .dx-row > td:hover:not(.dx-command-select):not(.dx-command-expand):not(.dx-editor-cell):not(.dx-command-edit):not(.dx-datagrid-group-space) *** remove ***
                '&.dx-datagrid-headers.dx-header-multi-row .dx-datagrid-content .dx-datagrid-table .dx-row.dx-header-row > td': {
                    borderRight: '1px solid #3f3f3f',
                    borderLeft: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-header-panel': {
                    borderBottom: '1px solid #3f3f3f',
                    backgroundColor: '#2b2b2b',
                },
                '&.dx-datagrid-rowsview': {
                    borderTop: '1px solid #3f3f3f',
                    backgroundColor: '#323232',
                },
                '&.darkgrid .dx-datagrid-rowsview': {
                    //borderTop: '1px solid #3f3f3f',
                    backgroundColor: 'transparent',
                },
                '&.dx-datagrid-rowsview .dx-row.dx-edit-row:first-child > td': {
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-rowsview .dx-row.dx-edit-row > td': {
                    borderTop: '1px solid #3f3f3f',
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-rowsview .dx-master-detail-row .dx-master-detail-cell:not(.dx-row-lines), .dx-datagrid-rowsview .dx-master-detail-row > .dx-datagrid-group-space': {
                    borderTop: '1px solid #3f3f3f',
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-rowsview .dx-row-removed > td': {
                    borderTop: '1px solid #3f3f3f',
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-rowsview .dx-row-focused.dx-data-row > td, .dx-datagrid-rowsview .dx-row-focused.dx-data-row > tr:last-child > td': {
                    borderBottom: '1px solid #d07c22',
                },
                '&.dx-datagrid-bottom-load-panel': {
                    borderTop: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-total-footer': {
                    borderBottom: '1px solid #3f3f3f',
                    borderTop: '1px solid #3f3f3f',
                },
                '&.dx-datagrid-group-panel .dx-group-panel-item': {
                    background: '#323232',
                },
                '&.dx-datagrid-group-panel .dx-sort': {
                    color: '#565757',
                },
                '&.dx-row.dx-datagrid-group-footer.dx-column-lines': {
                    borderBottom: '1px solid #3f3f3f',
                },
                '&.dx-row.dx-datagrid-group-footer > td': {
                    borderTop: '1px solid #3f3f3f',
                },
                '&.dx-treelist-rowsview .dx-row-focused.dx-data-row > td, .dx-treelist-rowsview .dx-row-focused.dx-data-row > tr:last-child > td': {
                    borderBottom: '1px solid #d07c22',
                },
                '&.dx-tabpanel .dx-tabs': {
                    borderBottom: '1px solid #4d4c4c',
                    marginBottom: '16px',
                },
                '&.dx-tabpanel .dx-tab': {
                    minWidth: '90px',
                    padding: '12px 16px',
                },
                '&.triptabs.dx-tabpanel .dx-tab': {
                    padding: '12px 14px',
                },
                // .dx-field-item:not(.dx-field-item-has-group):not(.dx-field-item-has-tabs):not(.dx-first-row):not(.dx-label-v-align) *** remove ***

                // ***** Devexpress theme colour overrides *****
                '&.dx-checkbox-icon': {
                    border: '1px solid rgba(151,152,152,.54)',
                    backgroundColor: '#2e2e2e',
                },
                //'&.dx-checkbox-indeterminate .dx-checkbox-icon': {
                //    backgroundColor: '#f78f1e',
                //},
                //'&.dx-pager .dx-page-sizes .dx-selection, .dx-pager .dx-pages .dx-selection': {
                //    backgroundColor: '#f78f1e',
                //},
                //'&.dx-checkbox-indeterminate .dx-checkbox-icon': {
                //    backgroundColor: '#f78f1e',
                //},
                '&.daterange .dx-button-mode-text.dx-state-hover': {
                    backgroundColor: '#39322aa1',
                },
                '&.daterange .dx-button-mode-text': {
                    backgroundColor: '#f78f1e14',
                },
                '&.daterange .dx-button-text': {
                    color: '#f78f1e',
                },
                '&.dx-button-mode-text.dx-button-default': {
                    color: '#f78f1e',
                },
                '&.dx-button.dx-button-default.dx-state-hover': {
                    backgroundColor: '#d77e1e',
                },
                '&.dx-button.dx-button-default.dx-state-focused': {
                    backgroundColor: '#d77e1e',
                },
                '&.dx-texteditor.dx-state-active::before, .dx-texteditor.dx-state-focused::before': {
                    borderBottom: '1px solid #f78f1e',
                },
                '&.dx-state-selected > .dx-treeview-item': {
                    color: '#f78f1e',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item.dx-state-hover:not(.dx-state-focused)': {
                    color: '#f78f1e',
                    backgroundColor: '#1a1a1a',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item': {
                    color: '#f78f1e',
                    backgroundColor: '#1a1a1a',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-focused > .dx-treeview-item': {
                    color: '#f78f1e',
                    backgroundColor: '#1a1a1a',
                },
                '&.dx-treeview-item.dx-state-hover': {
                    color: '#f78f1e',
                    backgroundColor: '#1a1a1a',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused': {
                    color: '#f78f1e',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused.dx-list-item-selected': {
                    color: '#f78f1e',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected': {
                    color: '#f78f1e',
                },
                '&.dx-tile.dx-state-focused, .dx-tile.dx-state-hover': {
                    backgroundColor: '#f78f1e',
                    color: '#2b2b2b',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: 0,
                    padding: '5px 0 5px',
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#ffffff',
                    [`&.${checkboxClasses.checked}`]: {
                        color: '#ffffff',
                    },
                    [`&.${checkboxClasses.indeterminate}`]: {
                        color: '#ffffff',
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: alpha('#000', 0.90),
                },
                arrow: {
                    color: alpha('#000', 0.90),
                },
            },
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2b2b2b',
                    borderColor: '#4d4c4c',
                    marginTop: 'unset',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    color: '#ffffff',
                    borderRadius: '4px',
                    borderColor: '#4d4c4c',
                    '&::placeholder': {
                        color: '#ffffff',
                    },
                    '&::-webkit-input-placeholder': {/* Chrome/Opera/Safari */
                        color: '#ffffff',
                    },
                    '&::-moz-placeholder': {/* Firefox 19+ */
                        color: '#ffffff',
                    },
                    '&:-ms-input-placeholder': {/* IE 10+ */
                        color: '#ffffff',
                    },
                    '&::-moz-placeholder': {/* Firefox 18- */
                        color: '#ffffff',
                    },
                },
            }
        },
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#979898',
                    '&:hover': {
                        backgroundColor: alpha('#fff', 0.10),
                        color: '#f78f1e',
                    },
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    color: '#979898',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    color: '#979898',
                    '&:hover': {
                        backgroundColor: alpha('#fff', 0.10),
                        borderRadius: '4px',
                        color: "#f78f1e"
                    },
                    '&.Mui-selected': {
                        color: '#ffffff'
                    }
                },
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '40px',
                    paddingLeft: '8px',
                    color: '#979898',
                    '&:hover': {
                        color: "#f78f1e"
                    },
                }
            }
        },
        MuiListItemText: {
            defaultProps: {
                primaryTypographyProps: {
                    variant: 'menuItemTitle'
                }
            }
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: {
                    variant: "h6",
                },
            },
            styleOverrides: {
                action: {
                    marginTop: "-4px",
                    marginRight: "-4px",
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    color: '#979898',
                    borderRadius: "4px",
                    boxShadow:
                        "rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px",
                    backgroundImage: "none",
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    maxWidth: '500px'
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                },
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                day: {
                    fontWeight: "300",
                },
            },
        },
        MuiPickersYear: {
            styleOverrides: {
                root: {
                    height: "64px",
                },
            },
        },
        MuiPickersCalendar: {
            styleOverrides: {
                transitionContainer: {
                    marginTop: "6px",
                },
            },
        },
        MuiPickersCalendarHeader: {
            styleOverrides: {
                iconButton: {
                    backgroundColor: "transparent",
                    "& > *": {
                        backgroundColor: "transparent",
                    },
                },
                switchHeader: {
                    marginTop: "2px",
                    marginBottom: "4px",
                },
            },
        },
        MuiPickersClock: {
            styleOverrides: {
                container: {
                    margin: `32px 0 4px`,
                },
            },
        },
        MuiPickersClockNumber: {
            styleOverrides: {
                clockNumber: {
                    left: `calc(50% - 16px)`,
                    width: "32px",
                    height: "32px",
                },
            },
        },
        MuiPickerDTHeader: {
            styleOverrides: {
                dateHeader: {
                    "& h4": {
                        fontSize: "2.125rem",
                        fontWeight: 400,
                    },
                },
                timeHeader: {
                    "& h3": {
                        fontSize: "3rem",
                        fontWeight: 400,
                    },
                },
            },
        },
        MuiPickersTimePicker: {
            styleOverrides: {
                hourMinuteLabel: {
                    "& h2": {
                        fontSize: "3.75rem",
                        fontWeight: 300,
                    },
                },
            },
        },
        MuiPickersToolbar: {
            styleOverrides: {
                toolbar: {
                    "& h4": {
                        fontSize: "2.125rem",
                        fontWeight: 400,
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: "6px",
                },
                variant: {
                    borderRadius: "6px",
                    borderBottomColor: '#4d4c4c',
                    borderTopColor: '#4d4c4c',
                    borderLeftColor: '#4d4c4c',
                    borderRightColor: '#4d4c4c',
                }
            },
        },
    },
});
export default theme
